import { Box, Stack, useTheme } from "@mui/material";
import React from "react";
import { CreateTicketAutocomplete } from "./TicketAutocomplete";
import { useFormContext } from "react-hook-form";
import {
  useGetAllTicketTemplates,
  useGetTicketTemplateByIdMutation,
} from "controller";
import { useSetAtom } from "jotai";
import { setAttachmentData, setChecklistData } from "../store/newTicketStore";
import { convertToHours } from "utilz/helpers";

export const TicketSummaryComponent = () => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: "12px 16px",
        width: "100%",
        borderRadius: "8px",
        backgroundColor: "#FFF",
      }}
    >
      <Stack
        direction={"row"}
        sx={{
          gap: "24px",
        }}
      >
        <TemplateSearch />
      </Stack>
    </Box>
  );
};

const TemplateSearch = () => {
  const theme = useTheme();
  const setChecklist = useSetAtom(setChecklistData);
  const setAttachment = useSetAtom(setAttachmentData);
  const { mutateAsync: getTicketTemplate } = useGetTicketTemplateByIdMutation();
  const {
    control,
    setValue: setFormValue,
    formState: { errors },
  } = useFormContext();
  const [searchQuery, setSearchQuery] = React.useState("");
  const [value, setValue] = React.useState(null);
  const { data: ticketTemplates, isLoading } = useGetAllTicketTemplates({
    searchQuery,
  });

  const handleTemplateSelect = async (selectedTemplate: string) => {
    try {
      const templateData = await getTicketTemplate(selectedTemplate);
      setFormValue("description", templateData?.template_description);
      setFormValue("summary", templateData?.template_summary);
      setFormValue("board", templateData?.board);
      setFormValue("priority", templateData?.priority);
      setFormValue("isBillable", templateData?.is_billable);
      setFormValue("urgency", templateData?.urgency);
      setFormValue("ticketType", templateData?.ticket_type);
      setFormValue("ticketSubType", templateData?.ticket_sub_type);
      setFormValue("impact", templateData?.impact);
      templateData?.sla && setFormValue("sla", templateData?.sla);
      setFormValue("tags", templateData?.tags);
      setFormValue("checklist", templateData?.checklist);
      setFormValue(
        "budgetedHours",
        convertToHours(templateData?.budgeted_hours) || "",
      );
      setFormValue("status", templateData?.ticket_status);
      setChecklist({ items: templateData?.checklist || [] });

      if (templateData?.attachments && templateData?.attachments?.length > 0) {
        const attachmentArray = templateData.attachments?.map(
          (attachment: any) => {
            return {
              key: attachment.mapping_id,
              name: attachment.original_name,
              progress: 100,
              size: parseInt(attachment.size),
              type: attachment.file_type,
              status: "Uploaded",
              responseData: attachment,
            };
          },
        );
        console.log(attachmentArray);
        setAttachment(attachmentArray);
      } else {
        setAttachment([]);
      }
    } catch (error) {}
  };
  return (
    <CreateTicketAutocomplete
      name={"summary"}
      freeSolo
      error={errors?.summary ? true : false}
      errorMessage={"Summary is required"}
      control={control}
      fullWidth
      options={ticketTemplates?.result || []}
      //   label="Who"
      placeholder="Summary *"
      value={value}
      onBlur={() => {
        setFormValue("summary", searchQuery, { shouldDirty: true });
      }}
      onChange={(event: any, newValue: any) => {
        setValue(newValue?.template_summary);
        handleTemplateSelect(newValue?.mapping_id);
      }}
      labelMappingKey="template_name"
      valueMappingKey="mapping_id"
      getOptionLabel={(option) =>
        typeof option === "string" ? option : `${option.template_summary}`
      }
      inputStyle={{
        color: theme.palette.lightBg.low,
        backgroundColor: theme.palette.neutral["005"],
        // py: "6px",
        borderRadius: "4px",
        border: `1px solid ${theme.palette.neutral["010"]}`,
      }}
      onInputChange={(event: any, newInputValue: any) => {
        setSearchQuery(newInputValue);
        setFormValue("summary", newInputValue, { shouldDirty: true });
      }}
      // @ts-ignore
      inputProps={{
        maxLength: 100,
      }}
      filterOptions={(options) => options}
    />
  );
};
